/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIChannelCreation
 */
export interface APIChannelCreation {
    /**
     * 
     * @type {string}
     * @memberof APIChannelCreation
     */
    readonly self: string;
    /**
     * 
     * @type {string}
     * @memberof APIChannelCreation
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof APIChannelCreation
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof APIChannelCreation
     */
    readonly creator: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIChannelCreation
     */
    members: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof APIChannelCreation
     */
    readonly messages: string;
    /**
     * 
     * @type {Date}
     * @memberof APIChannelCreation
     */
    readonly lastReadAt: Date;
}

/**
 * Check if a given object implements the APIChannelCreation interface.
 */
export function instanceOfAPIChannelCreation(value: object): value is APIChannelCreation {
    if (!('self' in value) || value['self'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('creator' in value) || value['creator'] === undefined) return false;
    if (!('members' in value) || value['members'] === undefined) return false;
    if (!('messages' in value) || value['messages'] === undefined) return false;
    if (!('lastReadAt' in value) || value['lastReadAt'] === undefined) return false;
    return true;
}

export function APIChannelCreationFromJSON(json: any): APIChannelCreation {
    return APIChannelCreationFromJSONTyped(json, false);
}

export function APIChannelCreationFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIChannelCreation {
    if (json == null) {
        return json;
    }
    return {
        
        'self': json['self'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'creator': json['creator'],
        'members': json['members'],
        'messages': json['messages'],
        'lastReadAt': (new Date(json['last_read_at'])),
    };
}

export function APIChannelCreationToJSON(value?: Omit<APIChannelCreation, 'self'|'creator'|'messages'|'last_read_at'> | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'description': value['description'],
        'members': value['members'],
    };
}

